﻿module App

open Fable.React
open Fable.React.Props
open Fable.SimpleHttp
open Fable.SimpleJson
open Msgs
open Pages
open Elmish.Navigation
open Messages
open Messages.Signup
open Ui.Language

type Page =
    | VendorAdd of Vendor.Add.Model

type Model =
    {
        ApiInfo : ApiInfo
        LanguageCodesAndNames: (string * string) list
        LanguagePrefrence: string
        TranslatedDictionary: string array
        TranslationError: JsonErrors<GetJsonErrors> option
        Page : Page
    }

let routeUpdate routeOpt =
    match routeOpt with
    | None ->
        let page, effects = Vendor.Add.init
        VendorAdd page, effects
    | Some route ->
        match route with
            | ToVendorAdd searchOpt ->
                let page, effects = Vendor.Add.init
                VendorAdd page, effects


let init (apiInfo : ApiInfo) routeOpt (*arg*) =
    let page, effects = routeUpdate routeOpt
    {
        ApiInfo =
            {
                ApiUrl = apiInfo.ApiUrl
            }
        LanguageCodesAndNames = []
        LanguagePrefrence = Ui.Language.Lang.DefaultLang
        TranslatedDictionary = [||] //Maybe set english as init
        TranslationError = None
        Page = page
    }, GetLanguagePreferenceFromLocal :: effects

let update (msg : Msg) (model : Model) : Model * List<Effect> =
    match model.Page, msg with
    | _, Navigate route ->
        let url = Route.toUrl route
        model, [SetUrl url]

    | _, LocalLanguageReturned (Ok (allLangCodes, returnedLang)) ->
        {model with LanguageCodesAndNames = allLangCodes;LanguagePrefrence = returnedLang}, []
    | _, LocalLanguageReturned (Error (oldLangCode, err)) ->
        {model with LanguagePrefrence = oldLangCode; TranslationError = Some err}, []
    | _, SetLanguage jsonResults ->
        match jsonResults with
        | Error err ->
            {model with TranslationError = Some err}, []
        | Ok stringArray ->
            {model with TranslatedDictionary = stringArray}, []
    | _, SelectLanguage language ->
        {model with LanguagePrefrence = language}, [ChangeLanguagePreference (model.LanguagePrefrence, language)]

    | VendorAdd page, VendorAddM msg ->
        let nPage, effects = Vendor.Add.update msg page
        { model with Page = VendorAdd nPage }, effects

    | VendorAdd _, _ ->
        model, []



let view (model: Model ) dispatch =
    let languageInformation =
        {
            LanguageCodesAndNames = model.LanguageCodesAndNames
            LanguagePrefrence = model.LanguagePrefrence
            TranslatedDictionary = model.TranslatedDictionary
            TranslationError = model.TranslationError
        }
    div [] [
        div [] [
            JSONFailed.handleJsonErrors model.TranslationError
            (match model.Page with
            | VendorAdd page ->
                Vendor.Add.view page languageInformation dispatch
            )
        ]
    ]


  ///////////////////
 // SIDE EFFECTS ///
///////////////////

//let perform model effect dispatch =
//    ()

let sendCommandToApi model tag command dispatch =

    let contentString = Json.stringify command
    let url = model.ApiUrl + "/signup"

    async {
        let! response =
            Http.request url
            |> Http.method POST
            |> Http.content (BodyContent.Text contentString)
            //|> Http.header (Headers.authorization ("Bearer " + model.AccessToken))
            |> Http.send
        let result =
            if response.statusCode <> 200 then
                Error (RequestFailed response)
            else
                let bodyString : string = response.responseText
                match Json.tryParseAs<Result<unit, SignupError>> bodyString with
                | Error err -> Error (ResponseParseFailed err)
                | Ok result ->
                    match result with
                    |Error err -> Error (ErrorResponse err)
                    | Ok _ -> Ok ()
        dispatch (tag result)
    }

let sendQueryToApi model ( tag : Result<Response,CommProblem<SignupError>> -> 'a ) query dispatch =

    let contentString = Json.stringify query
    let url = model.ApiUrl + "/signup"

    async {
        let! response =
            Http.request url
            |> Http.method POST
            |> Http.content (BodyContent.Text contentString )
            |> Http.send
        let ( result : Result<Response,CommProblem<SignupError>> ) =
            if response.statusCode <> 200 then
                Error (RequestFailed response)
            else
                // to retrieve from HTTP response
                let bodyString : string = response.responseText
                //handling the first result then second result inside queryResult
                match Json.tryParseAs<Result<Response, SignupError>> bodyString with
                | Error err ->  Error (ResponseParseFailed err)
                | Ok result ->
                    match result with
                    | Error err ->  Error (ErrorResponse err)
                    | Ok view ->  Ok view
        dispatch (tag result)

    }

let getLangFilePath langCode =
    sprintf "./Languages/%s.json" langCode

let getLanguageJSONFile path =
    async {
        let! response =
            Http.request path
            |> Http.method GET
            |> Http.send
        let result =
            if response.statusCode <> 200 then
                Error (JSONRequestFailed (response.statusCode, response.responseText))
            else
                let bodyString: string = response.responseText
                match Json.tryParseAs<string array> bodyString with
                | Error err ->
                    Error (FailedToGetLanguageFile err)
                | Ok lang ->
                    Ok lang
        return result
    }

let getLanguageCodesJSONFile =
    async {
        let! response =
            Http.request "./Languages/languages.json"
            |> Http.method GET
            |> Http.send
        let result =
            if response.statusCode <> 200 then
                Error (JSONRequestFailed (response.statusCode, response.responseText))
            else
                let bodyString: string = response.responseText
                match Json.tryParseAs<Map<string, string>> bodyString with
                | Error err ->
                    Error (FailedToGetLanguageFile err)
                | Ok lang ->
                    let lang =
                        Map.toList lang
                    Ok lang
        return result
    }

let getLanguageCodes =
    async {
        let! langCodesResult = getLanguageCodesJSONFile

        let langCodesResult =
            match langCodesResult with
            | Ok langCodes -> Ok langCodes
            | Error err -> Error err
        return langCodesResult
    }

open Browser

let changeLanguage oldLangCode langCode =
    let path = getLangFilePath langCode
    async {
        let! langCodesResult = getLanguageCodesJSONFile
        let! langResult = getLanguageJSONFile path

        let langCodesResult =
            match langCodesResult with
            | Ok langCodes -> Ok langCodes
            | Error err -> Error err

        match langResult with
        | Ok lang ->
            Lang.setLang lang
            localStorage.setItem(Lang.LocalStorageLangKey, langCode)
        | Error err ->
            Browser.Dom.console.log(err)

        let langResult =
            match langCodesResult, langResult with
            | Ok allLangCodes, Ok _ -> Ok (allLangCodes, langCode)
            | _, Error err -> Error (oldLangCode, err)
            | Error err, Ok _ -> Error (langCode, err)
        return langResult
    }


let runCmd dispatch (cmd : Elmish.Cmd<_>) =
    cmd
    |> List.iter (fun f -> f dispatch)


let perform model effect dispatch =
    let dispatchAsync tag msgAsync =
        async {
            let! msg = msgAsync
            dispatch (tag msg)
        } |> Async.StartImmediate
    match effect with
    | RunQuery query ->
        sendQueryToApi model ViewReturned query dispatch |> Async.StartImmediate
    | RunPageQuery (tag, query) ->
        sendQueryToApi model tag query dispatch |> Async.StartImmediate
    | RunCommand command ->
        sendQueryToApi model CommandReturned command dispatch |> Async.StartImmediate
    | RunPageCommand (tag, command) ->
        sendQueryToApi model tag command dispatch |> Async.StartImmediate
    | Passthru msg ->
        dispatch msg
    | SendDelayed (delayMs, msg) ->
        async {
            do! Async.Sleep delayMs
            dispatch msg
        } |> Async.StartImmediate
    | SetUrl url ->
        Navigation.newUrl url |> runCmd dispatch
    | GetLanguagePreferenceFromLocal ->
        let langCode =
            localStorage.getItem("language")
            |> Option.ofObj
            |> Option.defaultValue Lang.DefaultLang
        changeLanguage Lang.DefaultLang langCode |> dispatchAsync LocalLanguageReturned
    | ChangeLanguagePreference (oldLangCode, langCode) ->
        changeLanguage oldLangCode langCode |> dispatchAsync LocalLanguageReturned